import Default from "layouts/dashboards/default";
import Settings from "layouts/pages/account/settings";
import Billing from "layouts/pages/account/billing";
import Serviceauto from "layouts/pages/servicelists/auto";
import NewAutoLicense from "layouts/pages/servicelists/auto/new";
import EditAutoLicense from "layouts/pages/servicelists/auto/edit";
import Serviceecm from "layouts/pages/servicelists/ecm";
import ECMLicenseForm from "layouts/pages/servicelists/ecm/components/ECMLicenseForm";
import Serviceepm from "layouts/pages/servicelists/epm";
import NewEPMLicense from "layouts/pages/servicelists/epm/new";
import EditEPMLicense from "layouts/pages/servicelists/epm/edit";
import ServiceSBOffice from "layouts/pages/servicelists/sboffice";
import Servicesaas from "layouts/pages/servicelists/saas";
import SaasDetail from "layouts/pages/servicelists/saas/detail";
import Serviceiaas from "layouts/pages/servicelists/iaas";
import IaasDetail from "layouts/pages/servicelists/iaas/detail";
import Serviceiiasdiscover from "layouts/pages/servicelists/iaas/discover";
import Servicesaasdiscover from "layouts/pages/servicelists/saas/discover";
import PartnerDash from "layouts/pages/partner";
import AccountAVV from "layouts/pages/account/settings/avv";
import OrderCloudStorage from "layouts/pages/servicelists/iaas/products/uds-cloud-storage";
import OrderGameServer from "layouts/pages/servicelists/iaas/products/uds-game-server";
import OrderWebserver from "layouts/pages/servicelists/iaas/products/uds-webserver";
import CloudServerWizard from "layouts/pages/servicelists/iaas/products/cloud-server";
import NetworkRouterWizard from "layouts/pages/servicelists/iaas/products/network-router";
import PrivateCloudWizard from "layouts/pages/servicelists/iaas/products/private-cloud";
import S3StorageWizard from "layouts/pages/servicelists/iaas/products/s3-storage";
import PBXCloudWizard from "layouts/pages/servicelists/iaas/products/pbx-cloud";
import Login from "components/Login";
import ProtectedRoute from "components/ProtectedRoute";
import Contacts from "layouts/pages/account/contacts";
import Support from "layouts/pages/support";
import Documentation from "layouts/pages/documentation";

// Soft UI Dashboard PRO React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import SettingsIcon from "examples/Icons/Settings";
import Basket from "examples/Icons/Basket";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";

// SAAS Product Imports
import BackupNowWizard from "layouts/pages/servicelists/saas/products/backup";
import Office365Wizard from "layouts/pages/servicelists/saas/products/office365";
import TSPlusWizard from "layouts/pages/servicelists/saas/products/tsplus";
import ESETWizard from "layouts/pages/servicelists/saas/products/eset";
import LastPassWizard from "layouts/pages/servicelists/saas/products/lastpass";
import NextcloudWizard from "layouts/pages/servicelists/saas/products/nextcloud";
import CustomerDetail from "layouts/pages/partner/CustomerDetail";

const routes = [
  {
    type: "intern",
    name: "Login",
    key: "login",
    route: "/login",
    component: <Login />,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Shop size="12px" />,
    route: "/dashboard",
    component: (
      <ProtectedRoute>
        <Default />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  { type: "title", title: "Services", key: "title-services" },
  {
    type: "collapse",
    name: "IaaS",
    key: "iaas",
    icon: <SpaceShip size="12px" />,
    collapse: [
      {
        name: "Entdecken",
        key: "iaas-discover",
        route: "/iaas/discover",
        component: (
          <ProtectedRoute>
            <Serviceiiasdiscover />
          </ProtectedRoute>
        ),
      },
      {
        name: "Ihre Server",
        key: "iaas-server",
        route: "/iaas/server",
        component: (
          <ProtectedRoute>
            <Serviceiaas />
          </ProtectedRoute>
        ),
      }
    ],
  },
  {
    type: "intern",
    name: "IaaS Service Details",
    key: "iaas-detail",
    route: "/iaas/server/detail/:serviceId",
    component: (
      <ProtectedRoute>
        <IaasDetail />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "SaaS",
    key: "saas",
    icon: <Office size="12px" />,
    collapse: [
      {
        name: "Entdecken",
        key: "saas-discover",
        route: "/saas/discover",
        component: (
          <ProtectedRoute>
            <Servicesaasdiscover />
          </ProtectedRoute>
        ),
      },
      {
        name: "Ihre Apps",
        key: "saas-apps",
        route: "/saas/apps",
        component: (
          <ProtectedRoute>
            <Servicesaas />
          </ProtectedRoute>
        ),
      }
    ],
  },
  {
    type: "intern",
    name: "SaaS Service Details",
    key: "saas-detail",
    route: "/saas/detail/:serviceId",
    component: (
      <ProtectedRoute>
        <SaasDetail />
      </ProtectedRoute>
    ),
  },
  {
    type: "title",
    title: "UDS Produkte",
    key: "title-uds-products",
  },
  {
    type: "collapse",
    name: "UDS ECM",
    key: "services/ecm",
    productSlug: "ecm",
    icon: <Office size="12px" />,
    route: "/services/ecm",
    component: (
      <ProtectedRoute>
        <Serviceecm />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "intern",
    name: "New ECM License",
    key: "ecm-new",
    productSlug: "ecm",
    route: "/services/ecm/new",
    component: (
      <ProtectedRoute>
        <ECMLicenseForm />
      </ProtectedRoute>
    ),
  },
  {
    type: "intern",
    name: "Edit ECM License",
    key: "ecm-edit",
    productSlug: "ecm",
    route: "/services/ecm/edit/:id",
    component: (
      <ProtectedRoute>
        <ECMLicenseForm />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "UDS Automation Pro",
    key: "services/auto",
    productSlug: "auto",
    icon: <SpaceShip size="12px" />,
    route: "/services/auto",
    component: (
      <ProtectedRoute>
        <Serviceauto />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "intern",
    name: "New Auto License",
    key: "auto-new",
    productSlug: "auto",
    route: "/services/auto/new",
    component: (
      <ProtectedRoute>
        <NewAutoLicense />
      </ProtectedRoute>
    ),
  },
  {
    type: "intern",
    name: "Edit Auto License",
    key: "auto-edit",
    productSlug: "auto",
    route: "/services/auto/edit/:id",
    component: (
      <ProtectedRoute>
        <EditAutoLicense />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "UDS EP-Manager",
    key: "services/epm",
    productSlug: "epm",
    icon: <Shop size="12px" />,
    route: "/services/epm",
    component: (
      <ProtectedRoute>
        <Serviceepm />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "intern",
    name: "New EPM License",
    key: "epm-new",
    productSlug: "epm",
    route: "/services/epm/new",
    component: (
      <ProtectedRoute>
        <NewEPMLicense />
      </ProtectedRoute>
    ),
  },
  {
    type: "intern",
    name: "Edit EPM License",
    key: "epm-edit",
    productSlug: "epm",
    route: "/services/epm/edit/:id",
    component: (
      <ProtectedRoute>
        <EditEPMLicense />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "SBOffice",
    key: "services/sboffice",
    productSlug: "sboffice",
    icon: <Office size="12px" />,
    route: "/services/sboffice",
    component: (
      <ProtectedRoute>
        <ServiceSBOffice />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "intern",
    name: "SBOffice Details",
    key: "sboffice-detail",
    productSlug: "sboffice",
    route: "/services/sboffice/:tenantId",
    component: (
      <ProtectedRoute>
        <ServiceSBOffice />
      </ProtectedRoute>
    ),
  },
  { type: "title", title: "Mein Account", key: "title-my-account" },
  {
    type: "collapse",
    name: "Allgemeine Daten",
    key: "general-information",
    icon: <SettingsIcon size="12px" />,
    collapse: [
      {
        name: "Profil",
        key: "contact-data",
        route: "/account/contact-data",
        component: (
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        ),
      },
      {
        name: "Kontaktdaten",
        key: "contacts",
        route: "/account/contacts",
        component: (
          <ProtectedRoute>
            <Contacts />
          </ProtectedRoute>
        ),
      },
      {
        name: "Auftragsverarbeitung",
        key: "order-avv",
        route: "/account/order-avv",
        component: (
          <ProtectedRoute>
            <AccountAVV />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    type: "collapse",
    name: "Rechnungen",
    key: "billing",
    icon: <CreditCard size="12px" />,
    route: "/billing",
    component: (
      <ProtectedRoute>
        <Billing />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Support",
    key: "Support",
    icon: <CustomerSupport size="12px" />,
    route: "/Support",
    component: (
      <ProtectedRoute>
        <Support />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Dokumentationen",
    key: "documentation",
    icon: <CustomerSupport size="12px" />,
    route: "/documentation",
    component: (
      <ProtectedRoute>
        <Documentation />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "intern",
    name: "Dokumentation Seite",
    key: "documentation-product-page",
    route: "/documentation/:productSlug/*",
    component: (
      <ProtectedRoute>
        <Documentation />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Partnercenter",
    key: "partner-center",
    icon: <Basket size="12px" />,
    route: "/partner-center",
    component: (
      <ProtectedRoute>
        <PartnerDash />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "intern",
    key: "order-cloud-storage",
    route: "/order/cloud-storage",
    component: (
      <ProtectedRoute>
        <OrderCloudStorage />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    key: "order-game-server",
    route: "/order/game-server",
    component: (
      <ProtectedRoute>
        <OrderGameServer />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    key: "order-webserver",
    route: "/order/webserver",
    component: (
      <ProtectedRoute>
        <OrderWebserver />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    key: "order-cloud-server-windows",
    route: "/order/windows-cloud-server",
    component: (
      <ProtectedRoute>
        <CloudServerWizard serverType="windows" />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    key: "order-cloud-server-linux",
    route: "/order/linux-cloud-server",
    component: (
      <ProtectedRoute>
        <CloudServerWizard serverType="linux" />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    key: "order-network-router",
    route: "/order/private-network-router",
    component: (
      <ProtectedRoute>
        <NetworkRouterWizard />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    key: "order-private-cloud",
    route: "/order/private-cloud",
    component: (
      <ProtectedRoute>
        <PrivateCloudWizard />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    key: "order-s3-storage",
    route: "/order/s3-storage",
    component: (
      <ProtectedRoute>
        <S3StorageWizard />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    key: "order-pbx-cloud",
    route: "/order/pbx-cloud",
    component: (
      <ProtectedRoute>
        <PBXCloudWizard />
      </ProtectedRoute>
    )
  },
  // SAAS Product Routes
  {
    type: "route",
    name: "Backup Now",
    key: "backup-now",
    route: "/saas/products/backup-now",
    component: (
      <ProtectedRoute>
        <BackupNowWizard />
      </ProtectedRoute>
    )
  },
  {
    type: "route",
    name: "Office 365",
    key: "office-365",
    route: "/saas/products/office-365",
    component: (
      <ProtectedRoute>
        <Office365Wizard />
      </ProtectedRoute>
    )
  },
  {
    type: "route",
    name: "TSPlus",
    key: "tsplus",
    route: "/saas/products/tsplus",
    component: (
      <ProtectedRoute>
        <TSPlusWizard />
      </ProtectedRoute>
    )
  },
  {
    type: "route",
    name: "ESET",
    key: "eset",
    route: "/saas/products/eset",
    component: (
      <ProtectedRoute>
        <ESETWizard />
      </ProtectedRoute>
    )
  },
  {
    type: "route",
    name: "LastPass",
    key: "lastpass",
    route: "/saas/products/lastpass",
    component: (
      <ProtectedRoute>
        <LastPassWizard />
      </ProtectedRoute>
    )
  },
  {
    type: "route",
    name: "Nextcloud",
    key: "nextcloud",
    route: "/saas/products/nextcloud",
    component: (
      <ProtectedRoute>
        <NextcloudWizard />
      </ProtectedRoute>
    )
  },
  {
    type: "intern",
    name: "Kundendetails",
    key: "partner-customer-detail",
    route: "/partner/customer/:customerId",
    component: (
      <ProtectedRoute>
        <CustomerDetail />
      </ProtectedRoute>
    ),
    noCollapse: true
  },
];

export default routes;
